import { Outlet } from "@tanstack/react-router";
import { Header } from "../Header";
import { UserMenu } from "../UserMenu";

export function MainLayout() {
  return (
    <div className="min-h-screen bg-bg-primary">
      <main className="mx-auto max-w-2xl px-6 py-20">
        <Header>
          <UserMenu />
        </Header>
        <Outlet />
      </main>
    </div>
  );
}
